module.exports = __webpack_public_path__ + "img/fogo-do-grupo-workshop-samamaniacos.1900adde.jpg";